import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      persistent: "",
      "max-width": _vm.options.width
    },
    model: {
      value: _vm.isShown,
      callback: function callback($$v) {
        _vm.isShown = $$v;
      },
      expression: "isShown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.isValidating
    },
    on: {
      click: _vm.close
    }
  })], 1), _c(VCardTitle, {
    staticClass: "pb-0"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v(_vm._s(_vm.isAdding ? "New importer" : "Edit importer"))])]), _c("section", {
    staticClass: "content"
  }, [_c(VForm, {
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Name in platform",
      placeholder: "Name (for interface selector)",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("div", {
    staticClass: "mt-4"
  }, [_c(VTextField, {
    attrs: {
      label: "Mail address",
      placeholder: "Mail address",
      rules: [_vm.formRules.notRequiredEmail],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.mailContact,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mailContact", $$v);
      },
      expression: "form.mailContact"
    }
  })], 1), _c("div", {
    staticClass: "mt-4"
  }, [_c(VTextField, {
    attrs: {
      label: "Accounting code",
      placeholder: "Accounting code",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.accountingExternalId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "accountingExternalId", $$v);
      },
      expression: "form.accountingExternalId"
    }
  })], 1), _c("div", {
    staticClass: "mt-4"
  }, [_c(VCheckbox, {
    staticClass: "v-text-field-no-label",
    attrs: {
      label: "Receive emails from platform by default",
      disabled: String.isNullOrEmpty(_vm.form.mailContact)
    },
    model: {
      value: _vm.form.isDefaultReceiveEmails,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isDefaultReceiveEmails", $$v);
      },
      expression: "form.isDefaultReceiveEmails"
    }
  }), _c(VCheckbox, {
    staticClass: "v-text-field-no-label",
    attrs: {
      label: "Prevent automatic payments from platform"
    },
    model: {
      value: _vm.form.isPreventingPayment,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isPreventingPayment", $$v);
      },
      expression: "form.isPreventingPayment"
    }
  })], 1), _vm.isAdminNotConsultant(_vm.loggedUserData) || _vm.getFactoryProviders.length > 1 ? _c("div", {
    staticClass: "mt-4"
  }, [_c(VAutocomplete, {
    attrs: {
      label: "Financing option",
      items: _vm.getFactoryProviders,
      "item-value": "id",
      "item-text": "name",
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto",
      readonly: !_vm.canManageFactoringProviders || _vm.getFactoryProviders.length == 1
    },
    model: {
      value: _vm.form.factoringProviderId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "factoringProviderId", $$v);
      },
      expression: "form.factoringProviderId"
    }
  })], 1) : _vm._e(), _c("div", {
    staticClass: "mt-6"
  }, [_c("div", {
    staticClass: "withBeforeSeparator --smaller-padding"
  }), _c(VCheckbox, {
    attrs: {
      label: "C&M Customs invoice same as C&M invoice"
    },
    model: {
      value: _vm.form.isCustomsInvoiceSameAsInvoice,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isCustomsInvoiceSameAsInvoice", $$v);
      },
      expression: "form.isCustomsInvoiceSameAsInvoice"
    }
  })], 1), _c("div", [_c(VExpansionPanels, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c("span", {
    staticClass: "text-bold text-standalone-required"
  }, [_vm._v(" " + _vm._s(_vm.form.isCustomsInvoiceSameAsInvoice ? "Seller on invoice & customs invoice" : "Seller on invoice") + " ")])]), _c(VExpansionPanelContent, [_c("div", {
    staticClass: "dfwa-form"
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Name",
      placeholder: "Name",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.nameLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nameLine", $$v);
      },
      expression: "form.nameLine"
    }
  }), _c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Address (main)",
      placeholder: "XX Street",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.addressLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "addressLine1", $$v);
      },
      expression: "form.addressLine1"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Address (city)",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.addressLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "addressLine2", $$v);
      },
      expression: "form.addressLine2"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Tax ID",
      placeholder: "Tax ID # XX-XXXXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.taxIdLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "taxIdLine", $$v);
      },
      expression: "form.taxIdLine"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Import permit",
      placeholder: "TTB permit # AA-B-XXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.permitLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "permitLine", $$v);
      },
      expression: "form.permitLine"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Bond ID",
      placeholder: "BOND # AAXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.partnerLine3,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "partnerLine3", $$v);
      },
      expression: "form.partnerLine3"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Partner ID",
      placeholder: "PWDBW ID : XXXXXXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.partnerLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "partnerLine2", $$v);
      },
      expression: "form.partnerLine2"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Partner name",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.partnerLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "partnerLine1", $$v);
      },
      expression: "form.partnerLine1"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Phone",
      placeholder: "Phone",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.phoneLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "phoneLine", $$v);
      },
      expression: "form.phoneLine"
    }
  })], 1)])], 1)], 1), !_vm.form.isCustomsInvoiceSameAsInvoice ? _c("div", [_c(VExpansionPanels, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c("span", {
    staticClass: "text-bold text-standalone-required"
  }, [_vm._v(" Left side on customs invoice ")])]), _c(VExpansionPanelContent, [_c("div", {
    staticClass: "dfwa-form"
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Title",
      placeholder: "title on left side (Importer by)",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceLeftTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceLeftTitle", $$v);
      },
      expression: "form.customsInvoiceLeftTitle"
    }
  }), _c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Name",
      placeholder: "Name",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceLeftNameLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceLeftNameLine", $$v);
      },
      expression: "form.customsInvoiceLeftNameLine"
    }
  }), _c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Address (main)",
      placeholder: "XX Street",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceLeftAddressLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceLeftAddressLine1", $$v);
      },
      expression: "form.customsInvoiceLeftAddressLine1"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Address (city)",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceLeftAddressLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceLeftAddressLine2", $$v);
      },
      expression: "form.customsInvoiceLeftAddressLine2"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Tax ID",
      placeholder: "Tax ID # XX-XXXXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceLeftTaxIdLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceLeftTaxIdLine", $$v);
      },
      expression: "form.customsInvoiceLeftTaxIdLine"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Import permit",
      placeholder: "TTB permit # AA-B-XXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceLeftPermitLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceLeftPermitLine", $$v);
      },
      expression: "form.customsInvoiceLeftPermitLine"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Bond ID",
      placeholder: "BOND # AAXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceLeftPartnerLine3,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceLeftPartnerLine3", $$v);
      },
      expression: "form.customsInvoiceLeftPartnerLine3"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Partner ID",
      placeholder: "PWDBW ID : XXXXXXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceLeftPartnerLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceLeftPartnerLine2", $$v);
      },
      expression: "form.customsInvoiceLeftPartnerLine2"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Partner name",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceLeftPartnerLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceLeftPartnerLine1", $$v);
      },
      expression: "form.customsInvoiceLeftPartnerLine1"
    }
  }), _c(VTextField, {
    attrs: {
      label: "Phone",
      placeholder: "Phone",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceLeftPhoneLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceLeftPhoneLine", $$v);
      },
      expression: "form.customsInvoiceLeftPhoneLine"
    }
  })], 1)])], 1)], 1), _c(VExpansionPanels, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c("span", {
    staticClass: "text-bold text-standalone-required"
  }, [_vm._v(" Right side on customs invoice ")])]), _c(VExpansionPanelContent, [_c("div", {
    staticClass: "dfwa-form"
  }, [_c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Title",
      placeholder: "title on right side (Ship to)",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceRightTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceRightTitle", $$v);
      },
      expression: "form.customsInvoiceRightTitle"
    }
  })], 1), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Name",
      placeholder: "Name",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceRightNameLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceRightNameLine", $$v);
      },
      expression: "form.customsInvoiceRightNameLine"
    }
  })], 1), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Address (main)",
      placeholder: "XX Street",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceRightAddressLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceRightAddressLine1", $$v);
      },
      expression: "form.customsInvoiceRightAddressLine1"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Address (city)",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceRightAddressLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceRightAddressLine2", $$v);
      },
      expression: "form.customsInvoiceRightAddressLine2"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Tax ID",
      placeholder: "Tax ID # XX-XXXXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceRightTaxIdLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceRightTaxIdLine", $$v);
      },
      expression: "form.customsInvoiceRightTaxIdLine"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Import permit",
      placeholder: "TTB permit # AA-B-XXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceRightPermitLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceRightPermitLine", $$v);
      },
      expression: "form.customsInvoiceRightPermitLine"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Bond ID",
      placeholder: "BOND # AAXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceRightPartnerLine3,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceRightPartnerLine3", $$v);
      },
      expression: "form.customsInvoiceRightPartnerLine3"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Partner ID",
      placeholder: "PWDBW ID : XXXXXXXXX",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceRightPartnerLine2,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceRightPartnerLine2", $$v);
      },
      expression: "form.customsInvoiceRightPartnerLine2"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Partner name",
      placeholder: "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceRightPartnerLine1,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceRightPartnerLine1", $$v);
      },
      expression: "form.customsInvoiceRightPartnerLine1"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Phone",
      placeholder: "Phone",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.customsInvoiceRightPhoneLine,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "customsInvoiceRightPhoneLine", $$v);
      },
      expression: "form.customsInvoiceRightPhoneLine"
    }
  })], 1)])])], 1)], 1)], 1) : _vm._e()], 1), _c("div", {
    staticClass: "mt-4"
  }, [_c(VExpansionPanels, {
    model: {
      value: _vm.isCountriesExpanded,
      callback: function callback($$v) {
        _vm.isCountriesExpanded = $$v;
      },
      expression: "isCountriesExpanded"
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c("span", {
    staticClass: "text-bold text-standalone-required"
  }, [_vm._v("Locations available")])]), _c(VExpansionPanelContent, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: _vm.listCountriesRef,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "printable_name",
      "item-value": "id_country",
      label: "Country",
      required: "",
      rules: [_vm.formRules.mustSelectValue],
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.changeCountry();
      }
    },
    model: {
      value: _vm.form.countriesAvailable[0].id,
      callback: function callback($$v) {
        _vm.$set(_vm.form.countriesAvailable[0], "id", $$v);
      },
      expression: "form.countriesAvailable[0].id"
    }
  }), _vm.listStates.length > 0 ? _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: _vm.listStates,
      "hide-no-data": "",
      "item-text": "state_label",
      "item-value": "id_state",
      label: "States",
      required: true,
      rules: [_vm.formRules.mustSelectValue],
      "hide-details": "auto",
      multiple: "",
      chips: "",
      "deletable-chips": ""
    },
    model: {
      value: _vm.form.countriesAvailable[0].statesAvailableId,
      callback: function callback($$v) {
        _vm.$set(_vm.form.countriesAvailable[0], "statesAvailableId", $$v);
      },
      expression: "form.countriesAvailable[0].statesAvailableId"
    }
  }) : _vm._e(), true ? _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: _vm.customerTypesAvailable,
      "hide-no-data": "",
      "item-text": "name",
      "item-value": "id",
      label: "Customer type(s)",
      required: true,
      rules: [_vm.formRules.mustSelectValue],
      "hide-details": "auto",
      multiple: "",
      chips: "",
      "deletable-chips": ""
    },
    model: {
      value: _vm.form.countriesAvailable[0].customerTypesAvailable,
      callback: function callback($$v) {
        _vm.$set(_vm.form.countriesAvailable[0], "customerTypesAvailable", $$v);
      },
      expression: "form.countriesAvailable[0].customerTypesAvailable"
    }
  }) : _vm._e(), _c("div", {
    staticClass: "mt-4"
  }, [_c(VTextField, {
    attrs: {
      label: "Priority, if multiple importers are available for the same location. Higher is prioritary than 0",
      placeholder: "Priority",
      rules: [_vm.formRules.mustBeIntNotNegative],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.priority,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "priority", $$v);
      },
      expression: "form.priority"
    }
  })], 1)], 1)], 1)], 1)], 1), _c("div", {
    staticClass: "mt-6"
  }, [_c("div", {
    staticClass: "withBeforeSeparator --smaller-padding"
  }), _c(VCheckbox, {
    attrs: {
      label: "Platform generate final customer invoices"
    },
    on: {
      change: _vm.changeIsInternalImporter
    },
    model: {
      value: _vm.form.isInternalImporter,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isInternalImporter", $$v);
      },
      expression: "form.isInternalImporter"
    }
  }), _vm.form.isInternalImporter ? _c(VExpansionPanels, {
    model: {
      value: _vm.isInternalConfigExpanded,
      callback: function callback($$v) {
        _vm.isInternalConfigExpanded = $$v;
      },
      expression: "isInternalConfigExpanded"
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c("span", {
    staticClass: "text-bold"
  }, [_vm._v("Internal importer configuration")])]), _c(VExpansionPanelContent, [_c(VAlert, {
    staticClass: "--small",
    attrs: {
      dense: "",
      outlined: "",
      type: "warning",
      color: "orange",
      text: ""
    }
  }, [_vm._v(" If the importer is available for multiple states, it will generate only ONE GROUPED accountancy automation ")]), _c("div", {
    staticClass: "dfwa-form"
  }, [_c("section", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Invoices prefix, without final -",
      placeholder: "CM-COUNTRY&STATE-INV",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto",
      suffix: "-",
      maxlength: 20
    },
    model: {
      value: _vm.form.internalConfig.invoiceNumberingPrefix,
      callback: function callback($$v) {
        _vm.$set(_vm.form.internalConfig, "invoiceNumberingPrefix", $$v);
      },
      expression: "form.internalConfig.invoiceNumberingPrefix"
    }
  }), _c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Credit notes prefix, without final -",
      placeholder: "CM-COUNTRY&STATE-CN",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto",
      suffix: "-",
      maxlength: 20
    },
    model: {
      value: _vm.form.internalConfig.creditNoteNumberingPrefix,
      callback: function callback($$v) {
        _vm.$set(_vm.form.internalConfig, "creditNoteNumberingPrefix", $$v);
      },
      expression: "form.internalConfig.creditNoteNumberingPrefix"
    }
  }), _c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Nb chars of invoice/credit note number",
      placeholder: "9",
      rules: [_vm.formRules.mustBeGreaterOrEqualThan(5), _vm.formRules.mustBeLowerOrEqualThan(20)],
      "hide-details": "auto"
    },
    on: {
      keypress: _vm.filterIntegerKey
    },
    model: {
      value: _vm.form.internalConfig.invoiceNumberingNbChars,
      callback: function callback($$v) {
        _vm.$set(_vm.form.internalConfig, "invoiceNumberingNbChars", $$v);
      },
      expression: "form.internalConfig.invoiceNumberingNbChars"
    }
  }), _c("div", {
    staticClass: "display-switch"
  }, [_c("span", {
    class: _vm.form.internalConfig.isInvoiceNumberingUseAnnualCycle ? "" : "text-bold"
  }, [_vm._v(" Use order id as invoice/credit note number ")]), _c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.internalConfig.isInvoiceNumberingUseAnnualCycle,
      callback: function callback($$v) {
        _vm.$set(_vm.form.internalConfig, "isInvoiceNumberingUseAnnualCycle", $$v);
      },
      expression: "form.internalConfig.isInvoiceNumberingUseAnnualCycle"
    }
  }), _c("span", {
    class: !_vm.form.internalConfig.isInvoiceNumberingUseAnnualCycle ? "" : "text-bold"
  }, [_vm._v(" Iterates with following numbers, reset once a year ")])], 1), _vm.form.internalConfig.isInvoiceNumberingUseAnnualCycle ? _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: _vm.listMonths,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "name",
      "item-value": "id",
      label: "Month of reset",
      required: "",
      rules: [_vm.formRules.mustSelectValue],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.internalConfig.invoiceNumberingStartMonth,
      callback: function callback($$v) {
        _vm.$set(_vm.form.internalConfig, "invoiceNumberingStartMonth", $$v);
      },
      expression: "form.internalConfig.invoiceNumberingStartMonth"
    }
  }) : _vm._e()], 1), _c("section", {
    staticClass: "withBeforeSeparator"
  }, [_c(VTextarea, {
    staticClass: "required",
    attrs: {
      label: "Top left informations on documents",
      required: "",
      rules: [_vm.formRules.mustNotBeEmpty],
      rows: "2",
      "auto-grow": "",
      "no-resize": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.internalConfig.invoicingTopLeftInformations,
      callback: function callback($$v) {
        _vm.$set(_vm.form.internalConfig, "invoicingTopLeftInformations", $$v);
      },
      expression: "form.internalConfig.invoicingTopLeftInformations"
    }
  })], 1)])], 1)], 1)], 1) : _vm._e()], 1)])], 1), _c(VCardActions, {
    staticClass: "actions-bottom-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      disabled: _vm.isValidating
    },
    on: {
      click: _vm.close
    }
  }, [_vm._v(" Cancel ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      loading: _vm.isValidating,
      disabled: !_vm.form.valid
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(" " + _vm._s(_vm.isAdding ? "Create" : "Save") + " ")])], 1)], 1), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };